<h2 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{Title}}
</h2>

<mat-dialog-content>
    <div>
        <div *ngIf="DeleteForms">
            The selected Forms will be deleted and this cannot be undone.<br />
            Do you wish to proceed?
        </div>

        <div *ngIf="actionRequiresTree()">
            <div class="row">
                <div *ngIf="CopyForms" class="controls-column">
                    <mat-radio-group class="radio-group" [(ngModel)]="MoveOrCopy">
                        <mat-radio-button class="radio-button" value="copy">Copy</mat-radio-button>
                        <mat-radio-button class="radio-button" value="ref">Create Shortcut(s)</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div *ngIf="CreateFolder" class="controls-column">
                    <mat-form-field appearance="outline" class="form-name-mat-form-field">
                        <mat-label>Folder Name:</mat-label>
                        <input matInput
                               [(ngModel)]="this.EntityName"
                               placeholder="Folder Name"
                               name="folderName"
                               autocomplete="off"
                               required />
                    </mat-form-field>
                </div>

                <div *ngIf="CreateForm" class="controls-column">
                    <mat-form-field appearance="outline" class="form-name-mat-form-field">
                        <mat-label>Form Name:</mat-label>
                        <input matInput
                               [(ngModel)]="this.EntityName"
                               placeholder="Form Name"
                               name="formName"
                               autocomplete="off"
                               required />
                    </mat-form-field>
                </div>

                <!-- The Tree -->
                <div class="tree-column">
                    <p-tree [style]="{'height':'300px','overflow':'hidden','border':'1px solid grey'}"
                            [value]="TreeData"
                            selectionMode="single"
                            [(selection)]="SelectedTreeNode"
                            (onNodeSelect)="this.treeNodeSelected($event)"
                            scrollHeight="275px">

                        <ng-template let-node pTemplate="unselectable_Folder">
                            <span class="unselectable-folder">{{node.label}}</span>
                        </ng-template>
                    </p-tree>
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="ErrorMessage" class="error-message">
        {{ErrorMessage}}
    </div>
    <div *ngIf="Message" class="message">
        {{Message}}
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" class="theme-primary-btn" (click)="handleOk()" *ngIf="!ShowCloseButton" [disabled]="DisableOkButton">
        OK
    </button>
    <button mat-stroked-button (click)="closeDialog()">
        <ng-container *ngIf="!ShowCloseButton">Cancel</ng-container>
        <ng-container *ngIf="ShowCloseButton">Close</ng-container>
    </button>
</mat-dialog-actions>
